import React from "react";
import { Box, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, Typography } from "@mui/material";
import KenSelect from "../../../../../../GlobalComponents/KenSelect";
import { DROP_DOWN, QuizConfig } from '../Helper/AssessmentHelper';

interface ILayout {
    assessmentData: QuizConfig;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const Appearance = ({ assessmentData, handleChange }: ILayout) => {
    
    return (
        <Box sx={{ backgroundColor: "#f8f9fa", padding: 3, borderRadius: 2 }}>
            <Grid container spacing={3} textAlign="start">
                {/* Show the user's picture */}
                <Grid item xs={12}>
                    <FormControl component="fieldset">
                        <Typography variant="subtitle1">Show the user's picture</Typography>
                        <RadioGroup defaultValue="no-image" row>
                            <FormControlLabel
                                value="no-image"
                                control={<Radio sx={{ color: "#2f61ff", '&.Mui-checked': { color: "#2f61ff" } }} />}
                                label={<Typography sx={{ color: "#2f61ff", fontWeight: 600 }}>No image</Typography>}
                            />
                            <FormControlLabel value="small" control={<Radio sx={{ color: "#2f61ff", '&.Mui-checked': { color: "#2f61ff" } }} />} label="Smaller large" />
                            <FormControlLabel value="large" control={<Radio sx={{ color: "#2f61ff", '&.Mui-checked': { color: "#2f61ff" } }} />} label="Larger image" />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                {/* Decimal places in grades */}
                <Grid item xs={12}>
                    <FormControl component="fieldset">
                        <Typography variant="subtitle1">Decimal places in grades</Typography>
                        <RadioGroup defaultValue="1" row>
                            {[1, 2, 3, 4, 5].map((num) => (
                                <FormControlLabel
                                    key={num}
                                    value={num.toString()}
                                    control={<Radio sx={{ color: "#2f61ff", '&.Mui-checked': { color: "#2f61ff" } }} />}
                                    label={num.toString()}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>

                {/* Decimal places in question grades */}
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <Typography variant="subtitle1">Decimal places in question grades</Typography>
                        <KenSelect
                                          fullWidth
                                          name="decimalquestiongrades"
                                          value={assessmentData.decimalpoints}
                                          onChange={handleChange}
                                          options={DROP_DOWN.DecimalQuestionGrades}
                                          sx={{ height: '3rem', marginTop: 1 }}
                                      />
                    </FormControl>
                </Grid>

                {/* Show blocks during quiz attempts */}
                <Grid item xs={12}>
                    <FormControl component="fieldset">
                        <Typography variant="subtitle1">Show blocks during quiz attempts</Typography>
                        <RadioGroup defaultValue="yes" row>
                            <FormControlLabel
                                value="yes"
                                control={<Radio sx={{ color: "#2f61ff", '&.Mui-checked': { color: "#2f61ff" } }} />}
                                label={<Typography sx={{ color: "#2f61ff", fontWeight: 600 }}>Yes</Typography>}
                            />
                            <FormControlLabel value="no" control={<Radio sx={{ color: "#2f61ff", '&.Mui-checked': { color: "#2f61ff" } }} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Appearance;
